module.exports = __webpack_public_path__ + "img/farming_19.19ef7f10.png";